import { useNavigate } from 'react-router-dom';
import { useInfoSync } from './useInfoSync';
import {
  SHOPPING_CART,
  SHOPPING_CART_PED,
  SHOPPING_CART_PRV,
} from '../helpers/features';

export const usePermissions = () => {
  const { data: dataInfoSync } = useInfoSync();
  const navigate = useNavigate();

  const enableFeature = (feature) => {
    const enabled =
      {
        [SHOPPING_CART]: dataInfoSync?.usa_carrito === '1',
      }[feature] || false;

    !enabled && navigate('/contact');
    return enabled;
  };

  const enablePedido = (feature) => {
    const enabled =
      {
        [SHOPPING_CART_PED]: dataInfoSync?.usa_pedido === '1',
      }[feature] || false;
    //!enabled && navigate('/contact');
    return enabled;
  };

  const enablePresupuesto = (feature) => {
    const enabled =
      {
        [SHOPPING_CART_PRV]: dataInfoSync?.usa_presupuesto === '1',
      }[feature] || false;

    //!enabled && navigate('/contact');
    return enabled;
  };

  return { enableFeature, enablePedido, enablePresupuesto };
};
